module.exports = __webpack_public_path__ + "static/img/CgoRC2ORj2mAIdmiAAkWw-wXUxc533.9e748de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORj2mAIdmiAAkWw-wXUxc533.jpg
// module id = zRzn
// module chunks = 73